
export function formatDate(date: any): string {
  if (!date) return 'Recently';
  
  // Handle Firestore Timestamp
  if (typeof date.toDate === 'function') {
    return date.toDate().toLocaleDateString();
  }
  
  // Handle Date object
  if (date instanceof Date) {
    return date.toLocaleDateString();
  }
  
  // Handle string or number representing a date
  if (typeof date === 'string' || typeof date === 'number') {
    const d = new Date(date);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString();
    }
  }

  // Handle serverTimestamp estimates (objects with seconds/nanoseconds)
  if (date && typeof date.seconds === 'number') {
    return new Date(date.seconds * 1000).toLocaleDateString();
  }
  
  return 'Recently';
}

export function formatDateTime(date: any): string {
  if (!date) return 'Recently';
  
  if (typeof date.toDate === 'function') {
    return date.toDate().toLocaleString();
  }
  
  if (date instanceof Date) {
    return date.toLocaleString();
  }
  
  if (typeof date === 'string' || typeof date === 'number') {
    const d = new Date(date);
    if (!isNaN(d.getTime())) {
      return d.toLocaleString();
    }
  }

  if (date && typeof date.seconds === 'number') {
    return new Date(date.seconds * 1000).toLocaleString();
  }
  
  return 'Recently';
}

export function formatTime(date: any): string {
  if (!date) return 'Never';
  
  if (typeof date.toDate === 'function') {
    return date.toDate().toLocaleTimeString();
  }
  
  if (date instanceof Date) {
    return date.toLocaleTimeString();
  }
  
  if (typeof date === 'string' || typeof date === 'number') {
    const d = new Date(date);
    if (!isNaN(d.getTime())) {
      return d.toLocaleTimeString();
    }
  }

  if (date && typeof date.seconds === 'number') {
    return new Date(date.seconds * 1000).toLocaleTimeString();
  }
  
  return 'Never';
}
